import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { USER_LEVEL } from '@d-constants/user.constant';
import { CoreUserService } from '@d-services/core/user.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LevelGuard implements CanActivate {
  constructor(private userService: CoreUserService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean | UrlTree {
    return true;
    // TODO: PERMISSION
    //Can be displayed in both
    if (typeof route.data['isPOLocated'] === 'undefined') return true;
    if (route.queryParams['tenantId'] || route.queryParams['companyId'])
      return true;

    if (route.data['isPOLocated'] === true) {
      return this.userService.getUserLevel().level === USER_LEVEL.PO_LEVEL
        ? true
        : this.router.parseUrl('/home');
    } else {
      return this.userService.getUserLevel().level === USER_LEVEL.TENANT_LEVEL
        ? true
        : this.router.parseUrl('/home');
    }
  }
}
